import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import {
  PQRTamanhoTurmaDto,
  PQRNumeroDiasLetivosDto,
  PQRCargaHorarioEnsinoDto,
  PQRAlimentacaoEscolarDto,
  PQRManutencaoFormacaoMaterialDto,
  PQRQuadroFuncionariosRemuneracaoDto,
  PQRFormacaoJornadaRemuneracaoProfessoresDto,
  PQRNovasSalasPrediosDto,
  PqrQuantidadeNovasConstrucoesDto, PQRFatorPonderacaoDto
} from "../../dtos";
import { PQRTamanhoMinimoTurmaDto } from '../../dtos/pqr-tamanho-minimo-turma.dto';

@Injectable({
  providedIn: 'root',
})
export class CondicaoQualidadeStateService {
  carregando = new BehaviorSubject<boolean>(true);

  pQRNumeroDiasLetivosPadrao: PQRNumeroDiasLetivosDto[] = [];
  pQRNumeroDiasLetivosValores: PQRNumeroDiasLetivosDto[] = [];

  pQRCargaHorarioEnsinoPadrao: PQRCargaHorarioEnsinoDto[] = [];
  pQRCargaHorarioEnsinoValores: PQRCargaHorarioEnsinoDto[] = [];

  pQRTamanhoTurmasPadrao: PQRTamanhoTurmaDto[] = [];
  pQRTamanhoTurmasValores: PQRTamanhoTurmaDto[] = [];

  pQRTamanhoMinimoTurmasPadrao: PQRTamanhoMinimoTurmaDto[] = [];
  pQRTamanhoMinimoTurmasValores: PQRTamanhoMinimoTurmaDto[] = [];

  pQRFormacaoJornadaRemuneracaoProfessoresPadrao: PQRFormacaoJornadaRemuneracaoProfessoresDto[] = [];
  pQRFormacaoJornadaRemuneracaoProfessoresValores: PQRFormacaoJornadaRemuneracaoProfessoresDto[] = [];

  pQRQuadroFuncionariosRemuneracaoPadrao: PQRQuadroFuncionariosRemuneracaoDto[] = [];
  pQRQuadroFuncionariosRemuneracaoValores: PQRQuadroFuncionariosRemuneracaoDto[] = [];

  pQRManutencaoFormacaoMaterialPadrao: PQRManutencaoFormacaoMaterialDto[] = [];
  pQRManutencaoFormacaoMaterialValores: PQRManutencaoFormacaoMaterialDto[] = [];

  pQRAlimentacaoEscolarPadrao: PQRAlimentacaoEscolarDto[] = [];
  pQRAlimentacaoEscolarValores: PQRAlimentacaoEscolarDto[] = [];

  pQRNovasSalasPrediosPadrao: PQRNovasSalasPrediosDto[] = [];
  pqrQuantidadeNovasConstrucoesValores: PqrQuantidadeNovasConstrucoesDto[] = [];

  pQRFatorPonderacaoPadrao: PQRFatorPonderacaoDto[] = [];
  pQRFatorPonderacaoValores: PQRFatorPonderacaoDto[] = [];

  constructor() {}

  setPQRNovasSalasPrediosPadrao(data: PQRNovasSalasPrediosDto[]): void {
    this.pQRNovasSalasPrediosPadrao = data;
  }

  getPQRNovasSalasPrediosPadrao(): PQRNovasSalasPrediosDto[] {
    return this.pQRNovasSalasPrediosPadrao;
  }

  setPqrQuantidadeNovasConstrucoesValores(data: PqrQuantidadeNovasConstrucoesDto[]): void {
    this.pqrQuantidadeNovasConstrucoesValores = data;
  }

  getPqrQuantidadeNovasConstrucoesValores(): PqrQuantidadeNovasConstrucoesDto[] {
    return this.pqrQuantidadeNovasConstrucoesValores;
  }

  setPQRNumeroDiasLetivosPadrao(data: PQRNumeroDiasLetivosDto[]): void {
    this.pQRNumeroDiasLetivosPadrao = data;
  }

  getPQRNumeroDiasLetivosPadrao(): PQRNumeroDiasLetivosDto[] {
    return this.pQRNumeroDiasLetivosPadrao;
  }

  setPQRNumeroDiasLetivosValores(data: PQRNumeroDiasLetivosDto[]): void {
    this.pQRNumeroDiasLetivosValores = data;
  }

  getPQRNumeroDiasLetivosValores(): PQRNumeroDiasLetivosDto[] {
    return this.pQRNumeroDiasLetivosValores;
  }

  setPQRCargaHorarioEnsinoPadrao(data: PQRCargaHorarioEnsinoDto[]): void {
    this.pQRCargaHorarioEnsinoPadrao = data;
  }

  getPQRCargaHorarioEnsinoPadrao(): PQRCargaHorarioEnsinoDto[] {
    return this.pQRCargaHorarioEnsinoPadrao;
  }

  setPQRCargaHorarioEnsinoValores(data: PQRCargaHorarioEnsinoDto[]): void {
    this.pQRCargaHorarioEnsinoValores = data;
  }

  getPQRCargaHorarioEnsinoValores(): PQRCargaHorarioEnsinoDto[] {
    return this.pQRCargaHorarioEnsinoValores;
  }

  setPQRTamanhoTurmasPadrao(data: PQRTamanhoTurmaDto[]): void {
    this.pQRTamanhoTurmasPadrao = data;
  }

  getPQRTamanhoTurmasPadrao() :PQRTamanhoTurmaDto[]{
    return this.pQRTamanhoTurmasPadrao;
  }

  setPQRTamanhoTurmasValores(data: PQRTamanhoTurmaDto[]): void {
    this.pQRTamanhoTurmasValores = data;
  }

  getPQRTamanhoTurmasValores() :PQRTamanhoTurmaDto[]{
    return this.pQRTamanhoTurmasValores;
  }

  setPQRMinimoTurmasPadrao(data: PQRTamanhoMinimoTurmaDto[]): void {
    this.pQRTamanhoMinimoTurmasPadrao = data;
  }

  getPQRMinimoTurmasPadrao(): PQRTamanhoMinimoTurmaDto[] {
    return this.pQRTamanhoMinimoTurmasPadrao;
  }

  setPQRMinimoTurmasValores(data: PQRTamanhoMinimoTurmaDto[]): void {
    this.pQRTamanhoMinimoTurmasValores = data;
  }

  getPQRMinimoTurmasValores(): PQRTamanhoMinimoTurmaDto[] {
    return this.pQRTamanhoMinimoTurmasValores;
  }

  setPQRFormacaoJornadaRemuneracaoProfessoresPadrao(data: PQRFormacaoJornadaRemuneracaoProfessoresDto[]): void {
    this.pQRFormacaoJornadaRemuneracaoProfessoresPadrao = data;
  }

  getPQRFormacaoJornadaRemuneracaoProfessoresPadrao(): PQRFormacaoJornadaRemuneracaoProfessoresDto[] {
    return this.pQRFormacaoJornadaRemuneracaoProfessoresPadrao;
  }

  setPQRFormacaoJornadaRemuneracaoProfessoresValores(data: PQRFormacaoJornadaRemuneracaoProfessoresDto[]): void {
    this.pQRFormacaoJornadaRemuneracaoProfessoresValores = data;
  }

  getPQRFormacaoJornadaRemuneracaoProfessoresValores(): PQRFormacaoJornadaRemuneracaoProfessoresDto[] {
    return this.pQRFormacaoJornadaRemuneracaoProfessoresValores;
  }

  setPQRQuadroFuncionariosRemuneracaoPadrao(data: PQRQuadroFuncionariosRemuneracaoDto[]): void {
    this.pQRQuadroFuncionariosRemuneracaoPadrao = data;
  }

  getPQRQuadroFuncionariosRemuneracaoPadrao(): PQRQuadroFuncionariosRemuneracaoDto[] {
    return this.pQRQuadroFuncionariosRemuneracaoPadrao;
  }

  setPQRQuadroFuncionariosRemuneracaoValores(data: PQRQuadroFuncionariosRemuneracaoDto[]): void {
    this.pQRQuadroFuncionariosRemuneracaoValores = data;
  }

  getPQRQuadroFuncionariosRemuneracaoValores(): PQRQuadroFuncionariosRemuneracaoDto[] {
    return this.pQRQuadroFuncionariosRemuneracaoValores;
  }

  setPQRManutencaoFormacaoMaterialPadrao(data: PQRManutencaoFormacaoMaterialDto[]): void {
    this.pQRManutencaoFormacaoMaterialPadrao = data;
  }

  getPQRManutencaoFormacaoMaterialPadrao(): PQRManutencaoFormacaoMaterialDto[] {
    return this.pQRManutencaoFormacaoMaterialPadrao;
  }

  setPQRManutencaoFormacaoMaterialValores(data: PQRManutencaoFormacaoMaterialDto[]): void {
    this.pQRManutencaoFormacaoMaterialValores = data;
  }

  getPQRManutencaoFormacaoMaterialValores(): PQRManutencaoFormacaoMaterialDto[] {
    return this.pQRManutencaoFormacaoMaterialValores;
  }

  setPQRAlimentacaoEscolarPadrao(data: PQRAlimentacaoEscolarDto[]): void {
    this.pQRAlimentacaoEscolarPadrao = data;
  }

  getPQRAlimentacaoEscolarPadrao(): PQRAlimentacaoEscolarDto[] {
    return this.pQRAlimentacaoEscolarPadrao;
  }

  setPQRAlimentacaoEscolarValores(data: PQRAlimentacaoEscolarDto[]): void {
    this.pQRAlimentacaoEscolarValores = data;
  }

  getPQRAlimentacaoEscolarValores(): PQRAlimentacaoEscolarDto[] {
    return this.pQRAlimentacaoEscolarValores;
  }

  setPQRFatorPonderacaoPadrao(data: PQRFatorPonderacaoDto[]): void {
    this.pQRFatorPonderacaoPadrao = data;
  }

  getPQRFatorPonderacaoPadrao(): PQRFatorPonderacaoDto[] {
    return this.pQRFatorPonderacaoPadrao;
  }

  setPQRFatorPonderacaoValores(data: PQRFatorPonderacaoDto[]): void {
    this.pQRFatorPonderacaoValores = data;
  }

  getPQRFatorPonderacaoValores(): PQRFatorPonderacaoDto[] {
    return this.pQRFatorPonderacaoValores;
  }

 //Limpa todas as projeções editadas pelo usuário quando o usuário muda de localização.
  limparValoresEditados(): void {
    this.pQRNumeroDiasLetivosValores = [];
    this.pQRCargaHorarioEnsinoValores = [];
    this.pQRTamanhoTurmasValores = [];
    this.pQRTamanhoMinimoTurmasValores = [];
    this.pQRFormacaoJornadaRemuneracaoProfessoresValores = [];
    this.pQRQuadroFuncionariosRemuneracaoValores = [];
    this.pQRManutencaoFormacaoMaterialValores = [];
    this.pQRAlimentacaoEscolarValores = [];
    this.pqrQuantidadeNovasConstrucoesValores = [];
    this.pQRFatorPonderacaoValores = [];
  }
}
